import { useMemo } from 'react';
import useCollectionState from './useCollectionState';
import { useCollectionProgress } from '../collectionProgress';
import { useCompletedCollection } from '../ownedCollections';
import { EOwnedCollectionStatus } from '../types';
import { isEmptyObject } from '../../../utils/records';
var useCollectionGrid = function (collectionId) {
    var progressResponse = useCollectionProgress(collectionId);
    var state = useCollectionState(collectionId);
    var completedCollection = useCompletedCollection(collectionId);
    return useMemo(function () {
        var _a, _b, _c;
        if (!(progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection)) {
            return null;
        }
        var progress = progressResponse.progress, collection = progressResponse.collection, cards = progressResponse.cards;
        return {
            gridColumns: collection.numColumns,
            slots: collection.slots,
            specialGroups: (_a = ((progress === null || progress === void 0 ? void 0 : progress.status) === EOwnedCollectionStatus.COMPLETED
                ? progress === null || progress === void 0 ? void 0 : progress.specialGroups
                : undefined)) !== null && _a !== void 0 ? _a : collection === null || collection === void 0 ? void 0 : collection.specialGroups,
            progress: (_c = (_b = (completedCollection !== null && completedCollection !== void 0 ? completedCollection : progress)) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.map(function (slot) {
                var _a;
                if (isEmptyObject(slot)) {
                    return null;
                }
                var template = (_a = cards === null || cards === void 0 ? void 0 : cards.find(function (card) { return card._id === slot.card; })) === null || _a === void 0 ? void 0 : _a.cardTemplate;
                return template ? { cardId: slot.card, cardTemplate: template } : null;
            }),
            state: state,
        };
    }, [completedCollection, progressResponse, state]);
};
export default useCollectionGrid;
